import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import AccessAdminApp from './access-admin/App';
import RequestAccessApp from './request-access/App';
import { ThemeProvider } from './theme';
import './index.css';

function Router() {
  const path = window.location.pathname;

  if (path.startsWith('/dashboard/access-admin')) {
    return <AccessAdminApp />;
  }

  if (path.startsWith('/request-access')) {
    return <RequestAccessApp />;
  }

  // Default: security dashboard
  return <App />;
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ThemeProvider>
      <Router />
    </ThemeProvider>
  </React.StrictMode>
);
